<section class="manufacturer-check-page">
  <div class="custom-login background-image"></div>

  @if (orderToProcess) {
    <div class="manufacturer-check-shell">
      <div class="manufacturer-check-card">
        <h1 class="manufacturer-check-title">
          {{ pageTitle }}
        </h1>

        <app-check-order-selector
          [label]="selectorLabel"
          [value]="selectorValue"
          [tone]="selectorTone"
        ></app-check-order-selector>

        <input
          #ddtFileInput
          type="file"
          accept=".pdf"
          hidden
          (change)="onDdtSelected($event)"
        />

        @if (orderToProcess.ddt_url != "" && orderToProcess.ddt_url != null) {
          <p class="manufacturer-check-ddt-info">
            DDT selezionato: "
            <a href="{{ orderToProcess?.ddt_url }}" target="_blank">
              {{ orderToProcess.ddt_file }}
            </a>
            "
            <button
              type="button"
              class="certificates-step__icon certificates-step__icon--delete"
              (click)="removeDDT(orderToProcess?.supplier_certificate_id)"
            >
              <i class="bx bx-trash"></i>
            </button>
          </p>
        }

        @switch (activeStep) {
          @case (1) {
            <app-check-order-articles
              [products]="productsFromOrder"
              [selectedCode]="selectedArticleCode"
              (articleSelected)="selectArticle($event)"
              (articleAction)="addLot($event)"
              (openLot)="elaborateLot($event)"
            ></app-check-order-articles>
          }

          @case (2) {
            @if (!productToWorkOn?.is_manual_lot) {
              <app-check-order-range
                [selection]="rangeSelection"
                [productToWorkOn]="productToWorkOn"
                [newBatchToUpload]="newBatchToUpload"
                (newBatchToUploadChange)="newBatchToUpload = $event"
                (disableButton)="disableContinue = $event"
              ></app-check-order-range>
            } @else {
              <app-check-order-product
                [productToWorkOn]="productToWorkOn"
                [newBatchToUpload]="newBatchToUpload"
                (newBatchToUploadChange)="newBatchToUpload = $event"
                (disableButton)="disableContinue = $event"
              ></app-check-order-product>
            }
          }

          @case (3) {
            <app-check-order-upload
              [articleCode]="selectedArticleCode"
              [productToWorkOn]="productToWorkOn"
              [batchToAddFileTo]="newBatchToUpload"
              (goToList)="goToList($event)"
            ></app-check-order-upload>
          }

          @case (4) {
            <app-check-order-certificates
              [certificates]="certificates"
              [productToWorkOn]="productToWorkOn"
              [batchToAddFileTo]="newBatchToUpload"
              (certificateRemoved)="removeCertificate($event)"
              (certificateAdded)="addCertificate($event)"
            ></app-check-order-certificates>
          }

          @case (5) {
            @if (isViewingArticleLots) {
              <app-check-order-lots
                [lots]="selectedArticleLots"
                [productToWorkOn]="productToWorkOn"
                [batchToAddFileTo]="newBatchToUpload"
                [completed]="false"
              ></app-check-order-lots>
            } @else {
              <app-check-order-articles
                [products]="productsFromOrder"
                [selectedCode]="selectedArticleCode"
                [processedCodes]="visibleProcessedArticleCodes"
                [completed]="false"
                (articleSelected)="selectArticle($event)"
                (articleAction)="prepareAnotherArticle($event)"
                (openLot)="elaborateLot($event)"
              ></app-check-order-articles>
            }
          }

          @case (6) {
            <app-check-order-lots
              [lots]="selectedArticleLots"
              [productToWorkOn]="productToWorkOn"
              (batchSelected)="batchSelected($event)"
              (articleAction)="addLot($event)"
              [completed]="false"
              (openLot)="elaborateCustomRange($event)"
            ></app-check-order-lots>
          }
        }

        <div class="manufacturer-actions">
          @if (showBackAction) {
            <button
              type="button"
              class="manufacturer-action manufacturer-action--back"
              (click)="back()"
            >
              <i class="bx bx-left-arrow-circle"></i>
              <span>INDIETRO</span>
            </button>
          }

          @switch (activeStep) {
            @case (1) {
              @if (
                orderToProcess.ddt_url === "" || orderToProcess.ddt_url === null
              ) {
                <button
                  type="button"
                  class="manufacturer-action manufacturer-action--upload"
                  (click)="uploadDdt()"
                >
                  <i class="bx bx-folder-open"></i>
                  <span>CARICA DDT</span>
                </button>
              }
            }
            @case (2) {
              <button
                type="button"
                class="manufacturer-action manufacturer-action--continue"
                [disabled]="disableContinue"
                (click)="continueFromRange()"
              >
                <i class="bx bx-right-arrow-circle"></i>
                <span>CONTINUA</span>
              </button>
            }

            @case (3) {
              <button
                type="button"
                class="manufacturer-action manufacturer-action--save"
                [disabled]="!selectedArticleCode"
                (click)="saveUploadedCertificates()"
              >
                <i class="bx bx-check-circle"></i>
                <span>SALVA</span>
              </button>
            }

            @case (4) {
              <button
                type="button"
                class="upload-step__button"
                (click)="uploadCertificate()"
              >
                <i class="bx bx-plus-circle"></i>
                <span>AGGIUNGI CERTIFICATO</span>
              </button>
              <button
                type="button"
                class="manufacturer-action manufacturer-action--save"
                [disabled]="!selectedArticleCode"
                (click)="saveCertificates()"
              >
                <i class="bx bx-check-circle"></i>
                <span>SALVA</span>
              </button>
            }

            @case (5) {
              @if (isViewingArticleLots) {
                <button
                  type="button"
                  class="manufacturer-action manufacturer-action--secondary"
                  (click)="prepareAnotherArticle(selectedArticleCode)"
                >
                  <i class="bx bx-plus-circle"></i>
                  <span>AGGIUNGI LOTTO</span>
                </button>
              } @else if (
                orderToProcess.ddt_url === "" || orderToProcess.ddt_url === null
              ) {
                <button
                  type="button"
                  class="manufacturer-action manufacturer-action--upload"
                  (click)="uploadDdt()"
                >
                  <i class="bx bx-folder-open"></i>
                  <span>CARICA DDT</span>
                </button>
              }
              <button
                type="button"
                class="manufacturer-action manufacturer-action--save"
                [disabled]="!getConfirm"
                (click)="
                  confirmOrder(
                    orderToProcess.supplier_certificate_id,
                    orderToProcess.order_number
                  )
                "
              >
                <i class="bx bx-check-circle"></i>
                <span>CONFERMA</span>
              </button>
            }
            @case (6) {}
          }
        </div>
      </div>
      <div class="footer">©{{ currentYear }} | Connecta</div>
    </div>
  } @else {
    <span>loading...</span>
  }
</section>
